import { Link } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { MENU } from "@/lib/data";

export default function MenuPage() {
  return (
    <div data-testid="menu-page" className="bg-[#121212]">
      <section className="pt-20 md:pt-28 pb-12 border-b border-[#F5ECD7]/10">
        <div className="max-w-7xl mx-auto px-5 md:px-8">
          <p className="text-xs uppercase tracking-[0.3em] text-[#C99C3A] mb-5">The Menu</p>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[1.0] text-[#F5ECD7]">
            Crispy.{" "}
            <span className="font-serif-italic font-normal text-[#C99C3A]">Soulful.</span>{" "}
            Yours.
          </h1>
          <p className="mt-6 max-w-2xl text-[#F5ECD7]/65 text-lg">
            Sample menu — items rotate by location and season. Catering menu
            customizable to your event.
          </p>
        </div>
      </section>

      <section className="section-pad pb-0">
        <div className="max-w-5xl mx-auto px-5 md:px-8">
          <img src="/brand-images/menu-graphic.jpg" alt="Official #TacoSoul menu — Home of Deep Fried Tacos" className="w-full rounded-2xl border border-[#F5ECD7]/10" />
        </div>
      </section>

      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {MENU.map((item, i) => (
            <Reveal key={item.id} delay={(i % 2) * 120} className="group">
              <div className="bg-[#1A1A1A] border border-[#F5ECD7]/5 hover:border-[#C99C3A]/40 transition-colors rounded-2xl overflow-hidden">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-7 md:p-8">
                  <div className="flex items-baseline justify-between gap-4">
                    <h3 className="font-display text-2xl md:text-3xl tracking-tight text-[#F5ECD7]">{item.name}</h3>
                    <span className="font-display text-2xl text-[#C99C3A] shrink-0">{item.price}</span>
                  </div>
                  <p className="mt-3 text-[#F5ECD7]/65 leading-relaxed">{item.blurb}</p>
                  {item.tags.length > 0 && (
                    <div className="mt-5 flex gap-2 flex-wrap">
                      {item.tags.map((t) => (
                        <span key={t} className="text-[10px] uppercase tracking-[0.2em] border border-[#C99C3A]/40 text-[#C99C3A] px-2.5 py-1">{t}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="text-center mt-16 md:mt-24">
          <p className="font-serif-italic text-xl md:text-2xl text-[#F5ECD7]/70 max-w-xl mx-auto">
            Allergies, dietary preferences, custom catering menus —
          </p>
          <Link to="/contact" className="mt-6 inline-flex btn-gold" data-testid="menu-contact-cta">
            Ask the Chef
          </Link>
        </div>
      </section>
    </div>
  );
}
